import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const ApGestionApp = Loadable(lazy(() => import('./view/ArticuloPrecio')))
const ApRegistroApp = Loadable(lazy(() => import('./view/upsert/ApRegistro.tsx')))
const ApActualizarApp = Loadable(lazy(() => import('./view/upsert/ApActualizar.tsx')))

export const articuloPrecioRoutesMap = {
  gestion: {
    path: '/articulo-precio/gestion',
    name: 'Precios',
    actionSecure: 'PRECIOS',
  },
  registro: {
    path: '/articulo-precio/registro',
    name: 'Registro',
    actionSecure: 'REGISTRO',
  },
  editar: {
    path: '/articulo-precio/editar/:articuloId',
    name: 'Editar',
    actionSecure: 'EDITAR',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloPrecioRoutes = [
  {
    path: articuloPrecioRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ApGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloPrecioRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ApRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloPrecioRoutesMap.editar.path,
    element: (
      <OperacionesProvider>
        <ApActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default articuloPrecioRoutes
